const React = require("react");

function PlusCircleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    "aria-hidden": "true"
  }, props), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}

module.exports = PlusCircleIcon;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@heroicons/react/outline/PlusCircleIcon.js
 ** module id = 585
 ** module chunks = 0
 **/